export enum PurchaseMode {
	WithdrawInStore = 0,
	ReceiveAtHome = 1,
}
